var requestPrefix = "/api";

// var requestPrefix = "http://192.168.110.114:8094/api";
// var requestPrefix = "http://test-jiarong.ahjarzeng.com/api";
// var requestPrefix="http:///47.114.123.104:8080";
// var requestPrefix="http://192.168.31.112:8080";
//云
// var requestPrefix = "http://cloud.jrt-memos.com/api";
// var requestPrefix="http://test-jiarong-api.meiqicloud.com:8094";
// var requestPrefix="http://124.71.17.67:8094/";
// var requestPrefix="http://luyouxia8543.w3.luyouxia.net/collaboration/processInstance/formViewByRepairOrder";
// var requestPrefix = "http://127.0.0.1:8080";
// var requestPrefix = "http://1265jl90679ax.vicp.fun:30135";
const pageLimit = 20;
const pageSizeOpts = [10, 20, 50, 100];
export { requestPrefix, pageLimit, pageSizeOpts };



// WEBPACK FOOTER //
// ./src/assets/js/commonValue.js